import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
} from '@angular/forms';
import { ToastrService } from "ngx-toastr";

import { AppComponent } from '../../app.component';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';
import Swal from 'sweetalert2';
import { ExcelService } from '../../services/excel.service';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { SharedService } from '../../services/sharedService/shared.service'
import { postServiceWorkerMessage } from 'src/serviceworker/message';
import { WorkerMessageType } from 'src/serviceworker/service/events/message';
import { WorkerUrlPrefetchResult } from 'src/serviceworker/service/prefetch';
import { LoggerService } from 'src/app/services/logger.service';
import { decompress } from 'compress-json';

// import{Modal} from 'bootstrap'

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}
declare var $: any;
@Component({
  selector: 'app-manage-customers-new',
  templateUrl: './manage-customers-new.component.html',
  styleUrls: ['./manage-customers-new.component.css'],
  providers: [DatePipe],
})
export class ManageCustomersNewComponent implements OnDestroy, OnInit {
  brokerList: Array<any> = [];
  members: Array<any> = [];
  terminationDateValue: any;
  dateFormat = 'YYYY-MM-DD';

  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  @ViewChild('memberdetails') memberdetails: any;

  dtOptions: DataTables.Settings = {};
  persons: Array<any> = [];

  dtTrigger: Subject<any> = new Subject<any>();
  dtTrigger1: Subject<any> = new Subject<any>();
  customerslist: Array<any> = [];
  role: any;
  showmemberData = false;
  customerId: any;
  message: any
  popupDisplay: boolean = true;
  valuFormChaild: any = 0;
  emplomentName: any;
  loader: boolean
  // members: any;
  terminationform: FormGroup = new FormGroup({
    reason: new FormControl(''),
    memberstatus: new FormControl(''),
    terminationDate: new FormControl(''),


  });
  terminationformDetails: FormGroup = new FormGroup({
    reason: new FormControl(''),
    memberstatus: new FormControl(''),
    terminationDate: new FormControl(''),
    proceedWithEquitable: new FormControl(''),
    proceedWithGreenshield: new FormControl(''),
    proceedWithPHR: new FormControl(''),
    proceedWithRefund: new FormControl(''),
    refundAmount: new FormControl(),
    proceedWithSmartchoice: new FormControl(''),
    proceedWithSubscriptionExpiry: new FormControl(''),
    proceedWithCancelCustomer: new FormControl(''),

  });
  memberid: any;
  terminateReasonsWithKeys: any;
  Allmembers: any[];
  filterStatus: any[];
  minDate: Date;
  maxDate: Date;
  terminateMemberDetails: any;
  servicDetails: any;
  terminateReasonsApplicable: any;
  staxbillDetails: any;
  proceedWithSubscriptionExpiry: any;
  proceedWithEquitable: any;
  proceedWithGreenshield: any;
  proceedWithRefund: any;
  refundAmount:any;
  proceedWithSmartchoice: any;
  proceedWithCancelCustomer: any;
  terminationsProvisioning: any[];
  emplomentFirstName: any;
  emplomentLastName: any;
  invoicedetails: any
  showfilter: boolean = false;
  isSubscribed: any;
  public lang: any = {};
  selectedLanguage: string;
  languageData: any;
  constructor(private logger: LoggerService, private formBuilder: FormBuilder,
    private toastrService: ToastrService,


    private formBuilderDetails: FormBuilder,
    private SharedService: SharedService,

    private http: HttpClient, public router: Router, private datePipe: DatePipe, private excelService: ExcelService,) { }

  ngOnInit() {

    this.loader = false
    this.isSubscribed = false
    this.role = sessionStorage.getItem('role');

    this.terminationform = this.formBuilder.group({
      reason: [''],
      memberstatus: [''],
      terminationDate: ['', [Validators.required],],
    });
    this.dtOptions = {
      pagingType: 'simple_numbers',
      order: [],
      language: {
        searchPlaceholder: 'Search here...'
      },
      columnDefs: [
        {
          targets: '_all', // Index of the 'id' column
          orderable: false, // Disable sorting for this column
        },
      ],
    };



    this.getclientList();
    this.getLanguageTokens()
    // this.getServiceWorkerDetails();
  }

  public getLanguageTokens(){
    let body= {
      "project":"Admin Portal",
      "url":"manageMembers"
    }
    this.http
    .post('https://languageengineapi.aitestpro.com/string/project-url-strings',body, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .subscribe(
      (response: any) => {
        console.log(response)
        this.lang = {};
        this.languageData = response.strings
        this.selectedLanguage = sessionStorage.getItem("language")
        for (let token of response.strings) {
          this.lang[token.key] = token[this.selectedLanguage];
        }

        console.log(this.lang)

      })


  }
  public note: string = ""
  public enroll: any

  setMinDateBasedOnRoleAndStatus(client: any) {
    const today = new Date();
    if (this.role === 'BROKER') {
      this.minDate = today;
      this.note = this.lang.Required_backdated_selection_contact_Administrator
      return
    } else if (this.role === 'ADMINISTRATOR') {
      const threeMonthsFromNow = new Date(today.setMonth(today.getMonth() - 3));
      this.minDate = new Date(threeMonthsFromNow.getFullYear(), threeMonthsFromNow.getMonth(), 1);

      if (client.status === "Active" && client.customerSignup?.enrollmentDate) {
        this.enroll = new Date(client.customerSignup?.enrollmentDate)
        this.logger.log(this.minDate <= this.enroll)

        if (this.minDate <= this.enroll && this.enroll < new Date()) {
          this.minDate = this.enroll
          this.note = this.lang.enrollment_date_is_the_earliest_selection
          this.logger.log("mindate", this.minDate)
          return
        }

        if (this.minDate < this.enroll && this.enroll >= new Date()) {
          this.minDate = new Date()
          this.note = this.lang.Today_is_the_earliest_selection
          this.logger.log("mindate", this.minDate)
          return
        }
        this.note = this.lang.Can_select_from_3_months_from_the_past
      }
      if (client.status === "Draft") {
        this.minDate = null
        this.note = ""
        return
        // this.logger.log("mindate draft", this.minDate)
      }
      this.logger.log("mindate", this.minDate)
    }

  }

  terminationformDetailsValidations() {
    this.terminationformDetails = this.formBuilderDetails.group({
      reason: ['', [Validators.required],],
      memberstatus: ['', [Validators.required],],
      terminationDate: ['', [Validators.required],],
      proceedWithEquitable: [''],
      proceedWithGreenshield: [''],
      proceedWithPHR: [''],

      proceedWithRefund: [''],
      refundAmount: [''],
      proceedWithSmartchoice: [''],
      proceedWithSubscriptionExpiry: [''],
      proceedWithCancelCustomer: [''],


    });
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger1.next(null);
    });
  }
  viewsubBrokerList(brokerlist) {

    $('#subGroupList-modal').modal('show');
    this.logger.log(brokerlist)
    this.customerslist = brokerlist
    this.dtTrigger1.next(null);
    // $("#DataTables_Table_1").dataTable().OnDestroy()
    $("#DataTables_Table_1").dataTable().fnDestroy();

  }

  public viewBrokerDetails(broker: any, index: number) {

    this.router.navigate(['/manageAdvisors/editAdvisor/' + broker.id]);

    // /broker/{brokerId}/details

  }
  public planenrollmentdate: any

  terminatemember(client: any, index: number) {
    this.terminationform.reset();
    this.setMinDateBasedOnRoleAndStatus(client);
    this.emplomentFirstName = client.firstName;//client.name;
    this.emplomentLastName = client.lastName;//client.name;
    this.planenrollmentdate = client.customerSignup?.enrollmentDate
    this.memberid = client.id;
    $("#showmemberlist").modal('show');

  }


  isDisabled(){
    const checkVal = this.staxbillDetails ? this.staxbillDetails.refundApplicable == false ? true : false : true
    return checkVal;
  }

  submitterminationEnd() {

    this.terminateMemberDetails.proceedWithGreenshield = this.terminationformDetails.get('proceedWithGreenshield').value
    this.terminateMemberDetails.proceedWithRefund = this.terminationformDetails.get('proceedWithRefund').value
    this.terminateMemberDetails.proceedWithSmartchoice = this.terminationformDetails.get('proceedWithSmartchoice').value
    this.terminateMemberDetails.proceedWithSubscriptionExpiry = this.terminationformDetails.get('proceedWithSubscriptionExpiry').value
    this.terminateMemberDetails.proceedWithCancelCustomer = this.terminationformDetails.get('proceedWithCancelCustomer').value
    this.terminateMemberDetails.proceedWithEquitable = this.terminationformDetails.get('proceedWithEquitable').value
    this.terminateMemberDetails.proceedWithPHR = this.terminationformDetails.get('proceedWithPHR').value
    this.terminateMemberDetails.refundAmount = this.terminationformDetails.get('refundAmount').value


    let data = {
      'data': this.terminateMemberDetails,
      'reason': this.terminationformDetails.get('reason').value ?? " ",
    };

    this.logger.log(data);

    var corporateId = sessionStorage.getItem('corporateId');
    var accessToken = sessionStorage.getItem('accessToken');
    var terminate = '/api/ap/member/' + this.memberid + '/confirmMemberTermination';
    var headers = {
      Authorization: 'Bearer ' + accessToken,
      'Content-Type': 'application/json',
    };

    this.http.post(environment.apiUrl + terminate, data, { headers: headers })
      .subscribe(async (responce: any) => {
        this.logger.log("entering")
        console.log({ responce })

        if (responce.status == '200') {
          var details = '/api/ap/admin/customers/list';

          // await postServiceWorkerMessage(WorkerMessageType.Delete, [
          //   environment.apiUrl + details
          // ]);

          this.getclientList();
          // this.getServiceWorkerDetails()
          $("#DataTables_Table_0").dataTable().fnDestroy();
          Swal.fire({ title: "Info", html: responce.message }).then(async (res) => {
            if (res.isConfirmed) {



              // this.dtTrigger.next(null);
            }
          });
          $('#showTerminateMemberDetails').modal('hide');

        } else {
          Swal.fire({ title: "Info", text: responce.message });
        }

      }, (error) => {
        Swal.fire({ title: "Error", text: error.message || error.data.message });
      })
  }
  closeTerminatePopup(id: any) {
    $(`#${id}`).modal("hide");
    this.terminationform.reset();
  }

  submittermination() {
    if (this.terminationform.invalid) {
      this.terminationform.markAllAsTouched()
      this.toastrService.error(this.lang.Minimium_Date + `:${moment(this.minDate).format('MM-DD-YYYY')} \n` +this.lang.Note +`"${this.note}`);

      this.logger.log(this.terminationform.controls)
      return
    }
    this.logger.log(this.terminationform.value)
    var corporateId = sessionStorage.getItem('corporateId');
    var accessToken = sessionStorage.getItem('accessToken');
    var terminate = '/api/ap/member/' + this.memberid + '/configureMemberTermination';

    let data = {
      "reason": this.terminationform.value.reason,
      "memberStatus": this.terminationform.value.memberstatus,
      "terminationDate": this.datePipe.transform(
        this.terminationform.value.terminationDate,
        'yyyy-MM-dd'
      ) || ''
    }
    let terminateDate = this.datePipe.transform(this.terminationform.value.terminationDate, 'yyyy-MM-dd') || ''

    var corporateId = sessionStorage.getItem('corporateId');
    var accessToken = sessionStorage.getItem('accessToken');
    var terminate = '/api/ap/member/' + this.memberid + '/configureMemberTermination';
    // /member/{memberId}/configureMemberTermination
    let queryParams = new HttpParams();
    queryParams = queryParams.append("terminationDate", terminateDate);
    this.http
      .get(environment.apiUrl + terminate, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
        params: queryParams
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200 || response['statusCode'] == 200) {
            $("#showmemberlist").modal('hide');
            $('#showTerminateMemberDetails').modal('show');

            this.terminateMemberDetails = response.data;

            // alert(this.terminateMemberDetails.serviceType)

            this.logger.log("asasasa", this.terminateMemberDetails);
            this.terminateReasonsApplicable = this.terminateMemberDetails.terminateReasonsApplicable;
            this.servicDetails = this.terminateMemberDetails.serviceDetails;
            this.terminateReasonsWithKeys = response.data.terminateReasonsWithKeys;
            this.logger.log('terminateReasonsWithKeys', this.terminateReasonsWithKeys);
            this.staxbillDetails = this.terminateMemberDetails.staxbillDetails;

            let proceedWithEquitable = this.terminateMemberDetails.proceedWithEquitable;
            let proceedWithGreenshield = this.terminateMemberDetails.proceedWithGreenshield;
            let proceedWithPHR = this.terminateMemberDetails.proceedWithPHR
            let proceedWithRefund = this.terminateMemberDetails.proceedWithRefund;
            let refundAmount = this.staxbillDetails.refundAmount == 'NA' ? "N/A" : this.staxbillDetails.refundAmount;

            let proceedWithSmartchoice = this.terminateMemberDetails.proceedWithSmartchoice;
            let proceedWithSubscriptionExpiry = this.terminateMemberDetails.proceedWithSubscriptionExpiry;
            let proceedWithCancelCustomer = this.terminateMemberDetails.proceedWithCancelCustomer;

            this.terminationsProvisioning = response.data.terminationsProvisioning

            this.terminationformDetails.get('proceedWithEquitable').setValue(proceedWithEquitable);
            this.terminationformDetails.get('proceedWithGreenshield').setValue(proceedWithGreenshield);
            this.terminationformDetails.get('proceedWithPHR').setValue(proceedWithPHR);
            this.terminationformDetails.get('proceedWithRefund').setValue(proceedWithRefund);
            this.terminationformDetails.get('proceedWithSmartchoice').setValue(proceedWithSmartchoice);
            this.terminationformDetails.get('proceedWithSubscriptionExpiry').setValue(proceedWithSubscriptionExpiry);
            this.terminationformDetails.get('proceedWithCancelCustomer').setValue(proceedWithCancelCustomer);
            this.terminationformDetails.get('refundAmount').setValue(refundAmount);


            for (let control of Object.keys(this.terminationformDetails.controls)) {
              this.terminationformDetails.get(control).updateValueAndValidity();
            }
            // Swal.fire({ title: this.lang.Info, text: response.message })

          } else {
            Swal.fire({ title: this.lang.Error??'Error', text: response.message })
          }
        }, (error) => {
          if (error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error??'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: true,
              confirmButtonText: this.lang.Proceed,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
          }
        }
      );
  }

  closeModelPopup(id: any) {
    $('#' + id).modal('hide');
  }
  viewCustomerDetails(id: any) {
    this.router.navigate(['/customer/' + id + '/details']);
  }



  public addClientDetails() {
    this.router.navigate(['/addCorporate']);

  }
  scrollTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }


  // getServiceWorkerDetails() {
  //   var getClients = '/api/ap/admin/customers/list';

  //   let prefetchurls = []

  //   let Data = [{
  //     url: environment.apiUrl + getClients,
  //     // fetch options
  //     options: {
  //       mode: 'cors',
  //       headers: {
  //         Authorization: 'Bearer ' + sessionStorage.getItem('accessToken'),
  //         'Content-Type': 'application/json',
  //       }
  //     }
  //   }]
  //   prefetchurls = Data

  //   postServiceWorkerMessage(WorkerMessageType.Prefetch, prefetchurls).then((results: WorkerUrlPrefetchResult) => {
  //     $("#DataTables_Table_0").dataTable().fnDestroy();

  //     // this._LoaderService.HideLoader()


  //     setTimeout(() => {
  //       this.members = results[0].response.data;
  //       this.filterStatus = [];
  //       this.members.map((member) => {
  //         if (!this.filterStatus.includes(member.status))
  //           this.filterStatus.push(member.status);
  //       });
  //       this.logger.log("status", this.filterStatus);
  //       this.members.sort((a, b) => {
  //         const order = { Active: 1, Draft: 2, Suspended: 3, Hold: 4, Cancelled: 5, Incomplete: 6 };

  //         if (order[a.status] !== order[b.status]) {
  //           return order[a.status] - order[b.status];
  //         }
  //         // return a.firstName.localeCompare(b.firstName);
  //         const result = a.firstName.localeCompare(b.firstName);
  //         return result !== 0 ? result : a.lastName.localeCompare(b.lastName);
  //       });
  //       this.Allmembers = this.members;
  //       let filter//sorting get all active members sub sort by last name. append draft sub sort by last name

  //       this.dtTrigger.next(null);
  //       // this.members=response.data;
  //       this.loader = false
  //       setTimeout(() => {
  //         this.showfilter = true
  //       }, 1000);


  //     }, 1000)
  //   })
  // }

  public getclientList() {

    //https://testadminapi.groupbenefitz.aitestpro.com/api/ap/admin/customers/list

    var corporateId = sessionStorage.getItem('corporateId');
    var accessToken = sessionStorage.getItem('accessToken');
    // var getClients = '/api/ap/admin/customers/list';
    const role = sessionStorage.getItem('role')
    let getClients = ''
    if(role=='ADMINISTRATOR'){
      // getClients = 'http://[::1]:3002/api/ap/global/adminMembers';
      getClients = '/api/ap/global/adminMembers';
    }else{
      getClients = '/api/ap/admin/customers/list';
    }
    const that = this;

    this.loader = true;
    this.http
      .get(environment.apiUrl + getClients, {
      // .get( getClients, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {

          if (response['status'] == 200 || response['statusCode'] == 200) {
            // this.members = (response as any).data;
            if(role=='ADMINISTRATOR'){
              this.members = decompress(response.data)
            }else{
              this.members = response.data
            }
            this.filterStatus = [];
            this.members.map((member) => {
              if (!this.filterStatus.includes(member.status))
                this.filterStatus.push(member.status);
            });
            this.logger.log("status", this.filterStatus);
            this.members.sort((a, b) => {
              const order = { Active: 1, Draft: 2, Suspended: 3, Hold: 4, Cancelled: 5, Incomplete: 6 };

              if (order[a.status] !== order[b.status]) {
                return order[a.status] - order[b.status];
              }
              // return a.firstName.localeCompare(b.firstName);
              const result = a.firstName.localeCompare(b.firstName);
              return result !== 0 ? result : a.lastName.localeCompare(b.lastName);
            });
            this.Allmembers = this.members;
            let filter//sorting get all active members sub sort by last name. append draft sub sort by last name

            this.dtTrigger.next(null);
            this.logger.log(JSON.stringify(response));
            // this.members=response.data;
            this.loader = false
            setTimeout(() => {
              this.showfilter = true
            }, 1000);
          } else {
            this.loader = false
            Swal.fire({ title: this.lang.Error??'Error', text: response.message })
          }
        },
        (error) => {
          this.loader = false
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error??'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: true,
              confirmButtonText: this.lang.Proceed,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );
  }
  changeStatus(e: any) {
    this.showfilter = false;
    // this.Allmembers=this.members;
    $("#DataTables_Table_0").dataTable().fnDestroy();
    this.members = [];

    let val = e.target.value.toLowerCase();//member.status.toLowerCase()==val
    if (val == 'all') {
      this.members = this.Allmembers;
    } else {
      this.members = this.Allmembers.filter((member) => {
        if (member.status.toLowerCase() == val) {
          return member;
        }
      });
    }
    this.dtTrigger.next(null);
    this.logger.log(this.members);
    // this.showfilter = true

    setTimeout(() => {
      this.showfilter = true
    }, 500);
  }

  public deletebrokerDetails(broker: any, index: any) {

    this.logger.log(broker)
    // this.logger.log(index)
    var accessToken = sessionStorage.getItem('accessToken');
    var deleteBroker = '/api/ap/broker/' + broker.id + ''


    Swal.fire({
      title: this.lang.Alert,
      text: this.lang.Are_you_sure_you_want_to_delete_this,
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: this.lang.Proceed,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {

        this.http
          .delete(environment.apiUrl + deleteBroker, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          })
          .subscribe(
            (response: any) => {
              if (response['status'] == 200 || response['statusCode'] == 200) {
                // this.dtTrigger.next("");
                window.location.reload()
                // this.getBrokerList()
              } else {
                Swal.fire({ title: this.lang.Error??'Error', text: response.message })
              }
            },
            (error) => {
              if (
                error.status == 400 ||
                error.status == 401 ||
                error.status == 402 ||
                error.status == 403
              ) {
                Swal.fire({
                  title: this.lang.Error??'Error',
                  text: error.error.error.message,
                  showDenyButton: false,
                  showCancelButton: true,
                  confirmButtonText: this.lang.Proceed,
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                  else {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                });
              } else {
                // Swal.fire(error.error.error.message)
                Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
              }
              // this.toastrService.error("Invalid Credentials", 'Error!');
            }
          );
      }
    })

  }


  public showDetails(member: any, index: number) {

    this.customerId = member.id;
    sessionStorage.setItem("customerId", member.id);
    this.showmemberData = true;
    this.logger.log({ member })
    this.SharedService.setUserName(member.firstName + " " + member.lastName)
    sessionStorage.setItem('memberUserName', member.firstName + " " + member.lastName);

    this.router.navigate(['/manageMembers/employee/' + member.id + '/details']);

    // const modal = new Modal(this.memberdetails.nativeElement);
    // modal.show();
    // setTimeout(() => {
    //   // $('#memberdetails-modal').modal('show');

    // }, 100);

  }

  public brokerStatus(customer: any, event: any, index: number) {

    $("#DataTables_Table_0").dataTable().fnDestroy();

    var accessToken = sessionStorage.getItem('accessToken');
    // var brokerStatus = '/api/ap/broker/' + broker.id + '/activation/' + event
    var brokerStatus = '/api/ap/customer/' + customer.id + '/status/' + event

    let obj = {}
    Swal.fire({
      title: this.lang.Info,
      text: this.lang.Are_you_sure_you_want_to_change_this + customer.firstName + this.lang.Status+'?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: this.lang.Submit,
      cancelButtonText: this.lang.Close
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {

        this.http
          .put(environment.apiUrl + brokerStatus, obj, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          })
          .subscribe(
            (response: any) => {
              if (response['status'] == 200 || response['statusCode'] == 200) {
                // window.location.reload()
                this.getclientList()
              } else {
                Swal.fire({ title: this.lang.Error??'Error', text: response.message })
              }
            },
            (error) => {
              if (error.status == 400 ||
                error.status == 401 ||
                error.status == 402 ||
                error.status == 403
              ) {
                Swal.fire({
                  title: this.lang.Error??'Error',
                  text: error.error.error.message,
                  showDenyButton: false,
                  showCancelButton: true,
                  confirmButtonText: this.lang.Proceed,
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    // sessionStorage.clear();
                    // this.router.navigate(['/login']);
                  }
                  else {
                    // sessionStorage.clear();
                    // this.router.navigate(['/login']);
                  }
                });
              } else {
                // Swal.fire(error.error.error.message)
                Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
              }
              // this.toastrService.error("Invalid Credentials", 'Error!');
            }
          );
      }
      else {
        this.getclientList()
        // window.location.reload()
      }
    })

  }

  @ViewChild(ConfirmationDialogComponent) confirmationDialog: ConfirmationDialogComponent;

  // invitationMail(client: any) {
  //   this.logger.log({ client })
  //   this.message = `Are you sure you want to send invitation to ${client.firstName} ${client.lastName}?`
  //   $('#confirmationModal').modal('show');
  //   this.confirmationDialog.confirmed.subscribe(obj => {
  //     if (obj.confirmed) {
  //       var accessToken = sessionStorage.getItem('accessToken');
  //       var brokerStatus = '/api/ap/member/' + client.id + '/inviteMail'
  //       this.logger.log('invition Id', client.id)


  //       this.http
  //         .get(environment.apiUrl + brokerStatus, {
  //           headers: {
  //             Authorization: 'Bearer ' + accessToken,
  //             'Content-Type': 'application/json',
  //           },
  //         })
  //         .subscribe(
  //           (response: any) => {
  //             if (response['status'] == 200 || response['statusCode'] == 200) {
  //               // this.getclientList()
  //               // window.location.reload()
  //               Swal.fire({ title: this.lang.Info, text: response.message })
  //             } else {
  //               Swal.fire({ title: this.lang.Error??'Error', text: response.message })
  //             }
  //           },
  //           (error) => {
  //             if (
  //               error.status == 400 ||
  //               error.status == 401 ||
  //               error.status == 402 ||
  //               error.status == 403
  //             ) {
  //               Swal.fire({
  //                 title: this.lang.Error??'Error',
  //                 text: error.error.error.message,
  //                 showDenyButton: false,
  //                 showCancelButton: false,
  //                 // confirmButtonText: this.lang.Proceed,
  //               }).then((result) => {
  //                 if (result.isConfirmed) {
  //                 }
  //                 else {
  //                 }
  //               });
  //             } else {
  //               // Swal.fire(error.error.error.message)
  //               Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
  //             }
  //             // this.toastrService.error("Invalid Credentials", 'Error!');
  //           }
  //         );

  //     }
  //     $('#confirmationModal').modal('hide');
  //   });
  // }
  invitationMail(client: any) {
    // this.logger.log({ client });
    this.message = this.lang.Are_you_sure_you_want_to_send_an_invitation_to +` ${client.firstName} ${client.lastName}?`;
    $('#confirmationModal').modal('show');

    if (!this.isSubscribed) {
      this.confirmationDialog.confirmed.subscribe(obj => {
        this.isSubscribed = true;
        if (obj.confirmed) {
          this.sendInvitationEmail(client);
        }
        $('#confirmationModal').modal('hide');
      });
    }
  }

  sendInvitationEmail(client) {
    var accessToken = sessionStorage.getItem('accessToken');
    var brokerStatus = '/api/ap/member/' + client.id + '/inviteMail';
    this.logger.log('invitation Id', client.id);

    this.http.get(`${environment.apiUrl}${brokerStatus}`, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      },
    }).subscribe(
      response => this.handleResponse(response),
      error => this.handleError(error)
    );
  }

  handleResponse(response: any) {
    console.log({ response }, response['status'] === 200 || response['statusCode'] === 200, response.status)
    if (response['status'] == 200 || response['statusCode'] == 200) {
      Swal.fire({ title: this.lang.Info, text: response.message });
    } else {
      console.log("response")
      Swal.fire({ title: this.lang.Error??'Error', text: response.message });
    }
  }

  handleError(error: any) {
    Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
  }



  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }


  openModelAddMumber() {
    this.valuFormChaild++;
    this.router.navigate(['/manageMembers/addMember']);//member
    // alert('1212')
  }




}


export function moments(date: string | undefined): moment.Moment {

  if (date)

    return moment((new Date(date)).toJSON())

  else

    return moment();

}


